import { Component } from '@angular/core';

@Component({
  standalone: true,
  template: 'Authorizing...',
})
export class AuthorizeComponent {}
